import { ReactElement } from 'react';

import {
  Directions,
  FormField,
  IntegrationThemes,
} from '@cashier/cashier-model';
import { Select } from '@cashier/cashier-ui';

import { useDynamicDropdown } from './useDynamicDropdown';

export interface DynamicDropdownProps {
  field: FormField;
  onChange: (value: string) => void;
  theme?: IntegrationThemes;
  direction: Directions;
  version: 'v2' | 'v3';
  isDisabled: boolean;
}

export const DynamicDropdown = ({
  field,
  onChange,
  theme = IntegrationThemes.Default,
  direction,
  version,
  isDisabled,
}: DynamicDropdownProps): ReactElement => {
  const { options } = useDynamicDropdown();

  return (
    <Select
      name={field.name}
      direction={direction}
      label={field.label}
      options={options}
      defaultValue={''}
      theme={theme}
      isDisabled={isDisabled}
      onChange={onChange}
      version={version}
    />
  );
};
